import { createAxiosInstance } from '../utils/axiosConfig';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8083/api';

// Create axios instance with default config and interceptors
const fileAPI = createAxiosInstance({
  baseURL: API_BASE_URL,
});

fileAPI.interceptors.response.use(
  (response) => response,
  (error) => {
    const errorMessage = error.response?.data?.message || error.message || 'An error occurred';
    console.error('File API Error:', errorMessage);
    return Promise.reject(errorMessage);
  }
);

const normalizeUploadResponse = (data = {}) => {
  if (Array.isArray(data)) {
    return data;
  }

  if (data.uploadedFiles && Array.isArray(data.uploadedFiles)) {
    return data.uploadedFiles;
  }

  return data ? [data] : [];
};

export const fileService = {
  uploadProductImages: async (files) => {
    if (!files || files.length === 0) {
      return [];
    }

    const formData = new FormData();
    files.forEach((file) => {
      formData.append('files', file);
    });

    const response = await fileAPI.post('/files/upload/images', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    const uploads = normalizeUploadResponse(response.data);

    return uploads.map((item) => ({
      imageUrl: item.imageUrl || item.fullUrl || item.url || '',
      fullUrl: item.fullUrl || item.imageUrl || item.url || '',
      fileName: item.fileName || item.filename || '',
      originalName: item.originalName || item.originalFilename || '',
      fileSize: item.fileSize || item.size || 0,
      contentType: item.contentType || item.mimeType || '',
      success: item.success !== undefined ? item.success : true,
      message: item.message || '',
    }));
  },

  uploadProductVideos: async (files) => {
    if (!files || files.length === 0) {
      return [];
    }

    const formData = new FormData();
    files.forEach((file) => {
      formData.append('files', file);
    });

    const response = await fileAPI.post('/files/upload/multiple', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    const uploads = normalizeUploadResponse(response.data.files || response.data);

    return uploads.map((item) => ({
      videoUrl: item.fileUrl || item.url || '',
      fileName: item.fileName || item.filename || '',
      originalName: item.originalName || item.originalFilename || '',
      fileSize: item.fileSize || item.size || 0,
      contentType: item.contentType || item.mimeType || '',
      success: item.success !== undefined ? item.success : true,
      message: item.message || '',
    }));
  },
};

export default fileService;

